import { defineMessages, type MessageDescriptor } from 'react-intl';

export type ManageMemoryEditsMessageKey =
	| 'title'
	| 'subtitle'
	| 'deleteButton'
	| 'deleteSuccessMessage'
	| 'deleteErrorMessage'
	| 'emptyStateMessage'
	| 'loadingLabel'
	| 'errorMessage'
	| 'retryButton'
	| 'deleteConfirmHeading'
	| 'deleteConfirmDescription'
	| 'deleteConfirmCancel'
	| 'deleteConfirmRemove';

export const messages: Record<ManageMemoryEditsMessageKey, MessageDescriptor> = defineMessages({
	title: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.title',
		defaultMessage: 'Manage memory edits',
		description: 'Title of the manage memory edits subscreen',
	},
	subtitle: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.subtitle',
		defaultMessage:
			'Queue of all your suggested edits, these will be incorporated into your summary daily.',
		description: 'Subtitle of the manage memory edits subscreen describing when edits are applied',
	},
	deleteButton: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-button',
		defaultMessage: 'Delete',
		description: 'Accessible label for the delete button on a memory edit item',
	},
	deleteSuccessMessage: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-success-message',
		defaultMessage: 'Memory edit successfully removed.',
		description: 'Flag message shown after a memory edit is successfully deleted',
	},
	deleteErrorMessage: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-error-message',
		defaultMessage: "We couldn't delete this memory edit. Please try again.",
		description: 'Flag message shown when deleting a memory edit fails',
	},
	emptyStateMessage: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.empty-state-message',
		defaultMessage: 'No pending memory edits.',
		description: 'Message shown when there are no pending memory edits',
	},
	loadingLabel: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.loading-label',
		defaultMessage: 'Loading',
		description: 'Label to be read by screen readers when memory edits are loading',
	},
	errorMessage: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.error-message',
		defaultMessage: "We couldn't load your memory edits. Please try again.",
		description: 'Message shown when loading memory edits fails',
	},
	retryButton: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.retry-button',
		defaultMessage: 'Retry',
		description: 'Label for the retry button when loading memory edits fails',
	},
	deleteConfirmHeading: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-confirm-heading',
		defaultMessage: 'Are you sure you want to remove this edit?',
		description: 'Heading for the delete memory edit confirmation prompt',
	},
	deleteConfirmDescription: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-confirm-description',
		defaultMessage: 'This edit will be permanently removed from your queue.',
		description: 'Description for the delete memory edit confirmation (impact of removal)',
	},
	deleteConfirmCancel: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-confirm-cancel',
		defaultMessage: 'Cancel',
		description: 'Cancel button in delete memory edit confirmation',
	},
	deleteConfirmRemove: {
		id: 'ai-mate.rovo-memories.manage-memory-edits-subscreen.delete-confirm-remove',
		defaultMessage: 'Remove',
		description: 'Confirm remove button in delete memory edit confirmation',
	},
});
